import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ApolloError } from 'apollo-client';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import './FooterMobile.css';
import wallIcon from './toolbar_icon_wall.png';
import chatIcon from './toolbar_icon_chat.png';
import chatIconOffline from './toolbar_icon_chat_offline.png';
import { setUserData } from '../../utils/zopim';
import { getUserData } from '../../utils/graphQLFunctions';
import { userShape } from '../../utils/shapes';
import { Link } from 'react-router-dom';

const CHAT_STATUS_ONLINE = 'online';
const CHAT_STATUS_AWAY = 'away';
const CHAT_STATUS_OFFLINE = 'offline';

class FooterMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chatStatus: CHAT_STATUS_OFFLINE
    };

    this.openChat = this.openChat.bind(this);
    this.setChatStatus = this.setChatStatus.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.user !== this.props.data.user) {
      setUserData(nextProps.data.user);
    }

    if (window.$zopim && window.$zopim.livechat) {
      window.$zopim.livechat.setOnStatus(this.setChatStatus);
    }
  }

  openChat() {
    window.$zopim.livechat.window.show();
  }

  setChatStatus(status) {
    this.setState({
      chatStatus: status
    });
  }

  render() {
    const { chatStatus } = this.state;

    return (
      <div className="footer-mobile">
        <Navbar fixedBottom fluid>
          <Navbar.Header>
            <Nav>
              <NavItem>
                <Link to="/mobile/feed">
                  <div className="mobile-footer-container">
                    <img src={wallIcon} alt="Wall" />
                    Wall
                  </div>
                </Link>
              </NavItem>
              <NavItem onClick={this.openChat}>
                <div className="mobile-footer-container">
                  <img
                    src={
                      chatStatus === CHAT_STATUS_ONLINE
                        ? chatIcon
                        : chatIconOffline
                    }
                    alt="CM Chat"
                  />
                  CM Chat
                </div>
              </NavItem>
            </Nav>
          </Navbar.Header>
        </Navbar>
      </div>
    );
  }
}

FooterMobile.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.instanceOf(ApolloError),
      PropTypes.instanceOf(Error)
    ]),
    user: userShape
  })
};

export default getUserData()(FooterMobile);



// WEBPACK FOOTER //
// ./src/components/FooterMobile/index.js